import { supabase } from "@/shared/lib/supabase";

/**
 * Downloads an image from a URL and uploads it to S3, returning the S3 key
 * This is used during onboarding when scraping obituary images
 * Uses a Supabase Edge Function to handle CORS issues server-side
 */
export const uploadObituaryImageToS3 = async (
  imageUrl: string,
  estateId: number,
): Promise<string | null> => {
  try {
    // Use Supabase Edge Function to handle the image download and upload
    // This avoids CORS issues since the Edge Function runs server-side
    const { data, error } = await supabase.functions.invoke("onboarding/image/upload", {
      body: {
        imageUrl,
        estateId,
      },
    });

    if (error) {
      throw new Error(error.message || "Failed to upload obituary image");
    }

    return data.fileKey;
  } catch (error) {
    console.error("Error uploading obituary image to S3:", error);
    return null;
  }
};
